/**
 * Format pair symbol for BitMart WebSocket
 * Spot: BTC/USDT → BTC_USDT
 */
export function formatBitmartSymbol(pairSymbol: string): string {
  return pairSymbol.replace("/", "_");
}
